// Collection Page - Breadcrumb Capture Script (Production)
// Add this to your collection template

document.addEventListener('DOMContentLoaded', function() {
  
  // Function to capture current collection breadcrumbs
  function captureBreadcrumbs() {
    const breadcrumbData = {
      collections: [],
      timestamp: Date.now()
    };
    
    // Get breadcrumbs from your existing breadcrumb navigation
    const breadcrumbItems = document.querySelectorAll('.custom-breadcrumbs .items a');
    
    breadcrumbItems.forEach(function(item) {
      breadcrumbData.collections.push({
        title: item.textContent.trim(),
        url: item.getAttribute('href')
      });
    });
    
    return breadcrumbData;
  }
  
  // Add click listeners to all product links
  const productLinks = document.querySelectorAll('a[href*="/products/"]');
  
  productLinks.forEach(function(link) {
    link.addEventListener('click', function() {
      // Capture current breadcrumbs and store them
      const breadcrumbData = captureBreadcrumbs();
      
      // Only store if we actually found breadcrumbs
      if (breadcrumbData.collections.length > 0) {
        sessionStorage.setItem('lastCollectionBreadcrumbs', JSON.stringify(breadcrumbData));
      }
    });
  });
  
});